import { render } from "./MessagePage.vue?vue&type=template&id=183b05b0"
import script from "./MessagePage.vue?vue&type=script&lang=js"
export * from "./MessagePage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\amirhossein\\Project\\emad_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__